import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper } from '@material-ui/core';
import { useStyles } from './styles';
import { DevicesTable } from 'components/Tables/DevicesTable';

const Devices: FC = observer(() => {
  const classes = useStyles();
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <DevicesTable />
      </Paper>
    </Grid>
  );
});

export default Devices;
